function joinWaitlist() {
  var emailInput = document.getElementById("waitlist-email");
  var checkbox = document.querySelector('input[type="checkbox"]');
  // Validate Email
  if (!validateEmail(emailInput.value)) {
    alert("Please enter a valid email address.");
    return;
  }

  // Check if the terms have been accepted
  if (!checkbox.checked) {
    alert("Please agree to the Terms of Use and Privacy Policy.");
    return;
  }

  console.log(`emailInput.value:${emailInput.value}`);
  // Send Email to the Server if validations pass
  sendEmailToWaitlist(emailInput.value);
}

function validateEmail(email) {
  // This is a simple regex for email validation
  var re =
    /^(([^<>()\]\\.,;:\s@\"]+(\.[^<>()\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function sendEmailToWaitlist(email) {
  // Here you would send the email to the server
  const data = {
    email: email,
    product: "lite",
  };

  fetch("https://deeperchain-solana-swap.deeper.network/api/shopify/waiting", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
      alert(
        "You have been added to the waitlist, and we will keep you updated."
      );
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function openFullscreenVideo() {
  var videoModal = document.getElementById("videoModal");
  var video = document.getElementById("fullScreenVideo");

  // 显示视频模态框
  videoModal.style.display = "block";

  // 播放视频
  video.play();

  // 添加播放完毕事件监听器
  video.onended = function () {
    closeFullscreenVideo();
  };
}

function closeFullscreenVideo() {
  var videoModal = document.getElementById("videoModal");
  videoModal.style.display = "none";
  var video = document.getElementById("fullScreenVideo");
  video.pause(); // 暂停视频
  video.currentTime = 0; // 重置视频播放时间
}
